import { useEffect } from "react";

const ScreenProtection = () => {
    useEffect(() => {
        // Disable right click
        const handleContextMenu = (event: MouseEvent) => {
            event.preventDefault();
        };

        // Block common keyboard shortcuts
        const handleKeyDown = (event: KeyboardEvent) => {
            const key = event.key.toLowerCase();

            // Print Screen
            if (event.key === "PrintScreen") {
                event.preventDefault();

                // Try to clear clipboard
                navigator.clipboard?.writeText("").catch(() => { });

                document.body.classList.add("screen-captured");

                setTimeout(() => {
                    document.body.classList.remove("screen-captured");
                }, 1000);

                return;
            }

            // Ctrl/Cmd + S
            if ((event.ctrlKey || event.metaKey) && key === "s") {
                event.preventDefault();
                return;
            }

            // Ctrl/Cmd + P
            if ((event.ctrlKey || event.metaKey) && key === "p") {
                event.preventDefault();
                return;
            }

            // Ctrl/Cmd + U
            if ((event.ctrlKey || event.metaKey) && key === "u") {
                event.preventDefault();
                return;
            }

            // Ctrl/Cmd + Shift + I
            if (
                (event.ctrlKey || event.metaKey) &&
                event.shiftKey &&
                key === "i"
            ) {
                event.preventDefault();
                return;
            }

            // Ctrl/Cmd + Shift + J
            if (
                (event.ctrlKey || event.metaKey) &&
                event.shiftKey &&
                key === "j"
            ) {
                event.preventDefault();
                return;
            }

            // Ctrl/Cmd + Shift + C
            if (
                (event.ctrlKey || event.metaKey) &&
                event.shiftKey &&
                key === "c"
            ) {
                event.preventDefault();
                return;
            }

            // F12
            if (event.key === "F12") {
                event.preventDefault();
                return;
            }

            // Ctrl/Cmd + C
            if ((event.ctrlKey || event.metaKey) && key === "c") {
                event.preventDefault();
                return;
            }

            // Ctrl/Cmd + X
            if ((event.ctrlKey || event.metaKey) && key === "x") {
                event.preventDefault();
                return;
            }

            // Ctrl/Cmd + A
            if ((event.ctrlKey || event.metaKey) && key === "a") {
                event.preventDefault();
                return;
            }
        };

        // Disable copy
        const handleCopy = (event: ClipboardEvent) => {
            event.preventDefault();
        };

        // Disable cut
        const handleCut = (event: ClipboardEvent) => {
            event.preventDefault();
        };

        // Disable drag
        const handleDragStart = (event: DragEvent) => {
            event.preventDefault();
        };

        // Blur sensitive content when window loses focus
        const handleBlur = () => {
            document.body.classList.add("screen-blurred");
        };

        const handleFocus = () => {
            document.body.classList.remove("screen-blurred");
        };

        document.addEventListener("contextmenu", handleContextMenu);
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("copy", handleCopy);
        document.addEventListener("cut", handleCut);
        document.addEventListener("dragstart", handleDragStart);

        window.addEventListener("blur", handleBlur);
        window.addEventListener("focus", handleFocus);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("copy", handleCopy);
            document.removeEventListener("cut", handleCut);
            document.removeEventListener("dragstart", handleDragStart);

            window.removeEventListener("blur", handleBlur);
            window.removeEventListener("focus", handleFocus);
        };
    }, []);

    return null;
};

export default ScreenProtection;